import '../paedml-modal.tag'
import '../paedml-form-input.tag'

<paedml-modal-update-hub>
  <paedml-modal prefix={opts.prefix} 
      heading={opts.heading} opname={opts.opname} edit={opts.edit} 
      selectedrowsfunc={opts.selectedrowsfunc} idcol={opts.idcol} idtextcol={opts.idtextcol}
      submitfunc={submitHandler}>
  
    <yield to="fields">
      <div class="row">
        <div class="col-md-12">
          <p>Die paed.ML Hub Umgebung wird aktualisiert.</p>
        </div>
      </div>
      <div class="row">
          <div class="col-md-12">
            <div class="mt-2 mr-1 p-2 border border-info">
              <span><paedml-icon icon="fas-info-circle" simple="info" />
                  <strong class="text-info pl-1 pt-2">Update der paed.ML Hub Umgebung kann bis zu 5 Minuten dauern.</strong>
              </span>
              </div>
          <div class="p-2"></div>
          </div>
      </div>
      <div class="row">
        <div class="m-2 p-2">
          <span class="pl-1 pt-2">Es werden Jobs erstellt, um die paed.ML Hub Umgebung zu aktualisieren.</span>
          <p></p>
          <paedml-form-input name="redirect" placeholder="Nach der Ausführung zur 'JobQueue'-Ansicht springen" fgclass="py-1"
            type="checkbox" revlut="jaNein"
            />
        </div>
      </div>
    </yield>
  </paedml-modal>
    
    <script>
      import { handleSubmitCreateOrEdit } from '../../util/api-util'
      import API from '../../api'
      
      this.opname = this.opts.opname
      this.data = {}
      this.edit = true

      this.submitHandler = formData => {
      
      return API.hub.update().then(rsp => {
        const [data, status] = rsp
        if (status.error) return Promise.reject('Kommunikationsfehler mit dem Server')

        if(status.success) {
          
          if (this.data.redirect)  setTimeout(() => { 
            $('body').removeClass('modal-open')
            window.location.href = '/#jobverwaltung/jobs' 
          }, 500)

          this.parent.trigger('reloadTable')

          return 'Update des paed.ML Hubs wurde erfolgreich gestartet.'
        }
      })
    }
    </script>
</paedml-modal-update-hub>
